import React from 'react';
import { inject, observer } from 'mobx-react';
import { List, SimpleListItem } from '@rmwc/list';
import { SimpleMenuSurface } from '@rmwc/menu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

@inject('headerState')
@observer
class DesktopNav extends React.PureComponent {
  render() {
    const { mvcHomePath, memberSignedIn } = this.props.headerState;

    return (
      <nav className="mvc-nav mvc-mobile-hide">
        <ul className="inline-list">
          <li>
            <a href={mvcHomePath} className="mvc-nav-link">
              Home
            </a>
          </li>
          <li>
            <SimpleMenuSurface
              handle={
                <a className="mvc-nav-link">
                  About Us <FontAwesomeIcon icon={['far', 'chevron-down']} />
                </a>
              }
              anchorCorner="bottomLeft"
            >
              <List>
                <SimpleListItem
                  tag="a"
                  href="/mvc-awards/mission-statement"
                  text="Mission Statement"
                />
                <SimpleListItem
                  tag="a"
                  href="/mvc-awards/frequently-asked-questions"
                  text="FAQs"
                />
                <SimpleListItem
                  tag="a"
                  href="/mvc-awards/award-rules"
                  text="Award Rules"
                />
              </List>
            </SimpleMenuSurface>
          </li>
          <li>
            <a href="/mvc-awards/categories" className="mvc-nav-link">
              Categories
            </a>
          </li>
          <li>
            <a href="/mvc-awards/contact-us" className="mvc-nav-link">
              Contact
            </a>
          </li>
        </ul>

        {memberSignedIn || (
          <>
            <a className="mvc-login" href="/mvc-awards/sign_in">
              Log In
            </a>

            <a className="mvc-login" href="/mvc-awards/sign_up">
              Sign Up
            </a>
          </>
        )}
      </nav>
    );
  }
}

export default DesktopNav;
